module.exports = __webpack_public_path__ + "img/ps.f47d2f6b.svg";